var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 200,
    height: 59.8,
    viewBox: "0 0 200 59.8",
    style: {
      enableBackground: "new 0 0 200 59.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;fill-opacity:0;}\r\n\t.st1{fill:#334782;}\r\n\t.st2{fill:#D71F27;}\r\n\t.st3{fill:#333333;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.71204376220703,113.75937366485596)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -71.4,
    y: -95.8,
    className: "st0",
    width: 25,
    height: 22.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-71.4-95.8h9.6c3.6,0,6.2,2.5,6.2,6.1c0,3.5,0,7,0,10.5c0,3.2-2.1,5.6-5.1,6.1c-0.9,0.1-0.9,0.1-0.9-0.8 v-15c0-1,0-1-1-1c-1.4,0-2.8,0-4.1-0.2c-2.6-0.4-4.7-2.9-4.8-5.4C-71.4-95.5-71.4-95.7-71.4-95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-56.4-95.7h10l-5.1,8.4L-56.4-95.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-71-95.8v19h1.3v-7.4c0-2.8,2-5,4.8-5c3,0,4.3,1.9,4.3,4.7v7.7h1.3v-7.7c0-3.5-1.9-5.9-5.6-5.9 c-1.9,0-3.7,0.8-4.8,2.7v-8.1H-71z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-64-76.6c2.2,0,4.5-0.9,5.8-2.6l-1-0.8c-1,1.3-3.1,2-4.8,2c-2.8,0-5.2-1.8-5.5-5h12.1 c0.5-5.3-2.9-7.6-6.6-7.6c-3.8,0-6.8,2.9-6.8,6.9C-70.8-79.2-67.7-76.6-64-76.6z M-69.4-84c0.3-3.3,2.7-5.2,5.5-5.2 c3.2,0,5.4,1.8,5.4,5.2H-69.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-70.6-90.2v13.4h1.3v-7.8c0-2.4,1.9-4.5,4.4-4.5c0.8,0,1.6,0.2,2.3,0.6l0.6-1.1c-0.9-0.5-1.9-0.8-2.9-0.8 c-1.7,0-3.6,0.7-4.5,2.5l-0.1-2.4H-70.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-49.1-76.8v-8c0-3.3-2.3-5.7-5.6-5.7c-2.1,0-4.2,1.1-5,3.3c-0.8-2.4-2.9-3.3-5-3.3c-1.7,0-3.4,0.7-4.4,2.5 l0-2.2h-1.3v13.4h1.3v-8c0-2.6,1.7-4.5,4.3-4.5c2.6,0,4.3,1.9,4.3,4.5v8h1.3v-8c0-2.6,1.8-4.5,4.3-4.5s4.3,1.8,4.3,4.4v8H-49.1z "
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-63.2-76.6c3.8,0,6.8-2.6,6.8-6.9c0-4.3-3-7-6.8-7c-3.8,0-6.8,2.7-6.8,7C-70-79.2-67-76.6-63.2-76.6z  M-63.2-77.9c-3,0-5.5-2.1-5.5-5.6c0-3.5,2.5-5.7,5.5-5.7c3.1,0,5.5,2.3,5.5,5.7C-57.7-80-60.1-77.9-63.2-77.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-54.7-76.8v-19h-1.5v9h-12.1v-9h-1.5v19h1.5v-8.6h12.1v8.6H-54.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-62.7-76.6c2.2,0,4.5-0.9,5.8-2.6l-1-0.8c-1,1.3-3.1,2-4.8,2c-2.8,0-5.2-1.8-5.5-5h12.1 c0.5-5.3-2.9-7.6-6.6-7.6c-3.8,0-6.8,2.9-6.8,6.9C-69.5-79.2-66.5-76.6-62.7-76.6z M-68.2-84c0.3-3.3,2.7-5.2,5.5-5.2 c3.2,0,5.4,1.8,5.4,5.2H-68.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-56.9-90.2v2.9c-1.1-2.1-3.3-3.1-5.5-3.1c-3.8,0-6.8,2.8-6.8,6.9s3.1,6.9,6.8,6.9c2.2,0,4.2-1,5.5-3.1v2.9 h1.3c0-4.5,0-8.9,0-13.4H-56.9z M-62.4-89.1c7.5,0,7.5,11.2,0,11.2c-3,0-5.5-2.3-5.5-5.6C-67.9-86.9-65.5-89.1-62.4-89.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-69-95.8v19h1.3v-19H-69z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-66.1-94.1v3.9h-2.9v1.1h2.9v8.2c0,2.6,0.9,4.3,3.8,4.3c0.8,0,1.7-0.3,2.5-0.7l-0.5-1.1 c-0.7,0.3-1.4,0.5-2.1,0.5c-2.1,0-2.5-1.3-2.5-3.1v-8.2h4.6v-1.1h-4.6v-4L-66.1-94.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183, 1.7528363815319992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-68.8-95.8v19h1.3v-7.4c0-2.8,2-5,4.8-5c3,0,4.3,1.9,4.3,4.7v7.7h1.3v-7.7c0-3.5-1.9-5.9-5.6-5.9 c-1.9,0-3.7,0.8-4.8,2.7v-8.1H-68.8z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.340a8c2322ca2bfc3abc740f150c8f25.svg";
export { ForwardRef as ReactComponent };